import { RootState } from '../store';

export const selectFlagsConfig = (state: RootState) => state.flagsConfig;
